const PricesItem = ({ item }) => {
  return (
    <div className="flex items-center justify-between p-2 border-b text-sm tn:text-base lg:text-lg">
      <div className="text-left">{item.titleUa}:</div>
      <div className="grow"></div>
      <div className="text-[#002998ef] font-bold min-w-max ml-4 ">
        {item.price} ₴
      </div>
    </div>
  )
}

export default PricesItem
